<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :row-class-name="rowClassName"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :expand-config="{ reserve: true }"
      resizable
      border
      row-id="shipmentBatchCode"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-warning">
          <span style="font-size: 18px; color: #606266">{{
            $l('INDEX.order_tab_delivery_batch') || '交货批次'
          }}</span>

          <el-divider direction="vertical"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="batchDel()"
          >
            <i class="el-icon-delete"></i>
            {{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <i class="el-icon-delete tool-btn" @click="del(row)"></i>
      </template>
      <template v-slot:errorMsg="{ row }">
        <div>
          <span v-html="row.errorMsg"></span>
        </div>
      </template>
      <template v-slot:batchAmount="{ row }">
        <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span>
          {{ row.v_batchSalePriceAmount || 0 }} {{ row.v_salesCurrencyUnit }}
        </span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
    tableHeight: { type: Number, default: 400 },
  },
  data() {
    return {
      tableToolbar: { slots: { buttons: 'toolbar_form' } },
      rowClassName: ({ row }) => {
        const { shipmentBatchCode } = row
        if (!this.errorKeys || !this.errorKeys.length) return ''
        const index = this.errorKeys.findIndex(
          (key) => key === shipmentBatchCode
        )
        return index < 0 ? '' : 'bg-danger text-white'
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          fixed: 'left',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 60,
          slots: {
            default: 'opt',
          },
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_orderBatchNo') || '批次号',
          field: 'orderBatchNo',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_customer_name') || '客户名称',
          field: 'custName',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_endcustomer_name') || '终端客户',
          field: 'endCustName',
          minWidth: 130,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_customerOrderNo') || '客户订单号',
          field: 'contractNo',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          minWidth: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_importerPo') || '进口商PO',
          field: 'importerPo',
          minWidth: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentStartDate') ||
            '客户最早交期',
          field: 'shipmentDate',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentEndDate') ||
            '客户最晚交期',
          field: 'shipmentEndDate',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_cargoReadyDay') || '货好时间',
          field: 'deliveryDate',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_outBillType') || '出单类型',
          field: 'outBillType',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_dispatchPort') || '发运港口',
          field: 'dispatchPort',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_destinationPort') || '目的港口',
          field: 'destinationPort',
          minWidth: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.order_package_packingType') || '装箱方式',
          field: 'v_packingType',
          align: 'center',
          headerAlign: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_batchGoodsQty') || '批次产品总数量',
          field: 'batchGoodsQty',
          align: 'center',
          headerAlign: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_batchBoxQty') || '批次总箱数',
          field: 'batchBoxQty',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalBoxVolume') || '批次总体积（立方米）',
          field: 'batchVolume',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalNetWeight') || '批次总净重',
          field: 'batchNetWeight',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalGrossWeight') || '批次总毛重',
          field: 'batchGrossWeight',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_boxLength_cm') || '箱长（cm）',
          field: 'boxLength',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_boxWidth_cm') || '箱宽（cm）',
          field: 'boxWidth',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_boxHeight_cm') || '箱高（cm）',
          field: 'boxHeight',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_boxVolume') || '箱体积(m³)',
          field: 'boxVolume',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_Batch Price Amount') || '工厂金额',
          field: 'batchPriceAmount',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'batchAmount',
          },
        },
        {
          title: this.$l('INDEX.form_shipmentSalePrice') || '批次销售总价',
          field: 'batchSalePriceAmount',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'batchSalePrice',
          },
        },
      ],
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    },
    getCheckboxRecords() {
      const data = this.$refs.table.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      return data
    },
    del(row) {
      this.$emit('delete', [row])
    },
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data) return
      this.$emit('delete', data)
    },
  },
}
</script>
